import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Alert, Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../contexts/AuthContext";
import { accentText, AuthShell, GoogleMark, OrDivider } from "./marketing/MarketingParts";
import { EmailField, PasswordField } from "./marketing/AuthFields";

function getApiOrigin() {
  try {
    const base = String(window.__AW_RUNTIME_CONFIG__?.apiBaseUrl || "").replace(/\/$/, "");
    return base || window.location.origin;
  } catch {
    return "";
  }
}

export default function Login() {
  const { t } = useTranslation();
  const { login } = useContext(AuthContext);
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login({ email, password });
      nav("/sites");
    } catch (err) {
      setError(err?.response?.data?.message || t("mka_login_err"));
    }
  };

  const onGoogle = () => {
    const origin = getApiOrigin();
    const next = "/sites";
    window.location.href = `${origin}/api/auth/google/start?next=${encodeURIComponent(next)}`;
  };

  return (
    <AuthShell
      title={t("mka_login_title")}
      subtitle={t("mka_login_sub")}
      footer={
        <>
          {t("mka_no_account")}{" "}
          <Box component={Link} to="/register" sx={{ color: accentText, fontWeight: 600 }}>
            {t("mka_register_link")}
          </Box>
        </>
      }
    >
      <Box sx={{ display: "grid", gap: 2 }}>
        <Button onClick={onGoogle} variant="outlined" size="large" fullWidth startIcon={<GoogleMark />}>
          {t("mka_google_login")}
        </Button>
        <OrDivider label={t("mka_or")} />
        <Box aria-live="polite">{error ? <Alert severity="error">{error}</Alert> : null}</Box>
        <Box component="form" onSubmit={onSubmit} sx={{ display: "grid", gap: 2 }}>
          <EmailField label={t("mka_email")} value={email} onChange={(e) => setEmail(e.target.value)} />
          <PasswordField label={t("mka_password")} value={password} onChange={(e) => setPassword(e.target.value)} />
          <Typography variant="body2" sx={{ textAlign: "end", mt: -0.5 }}>
            <Box component={Link} to="/forgot-password" sx={{ color: accentText, fontWeight: 600 }}>
              {t("mka_forgot_link")}
            </Box>
          </Typography>
          <Button type="submit" variant="contained" size="large" fullWidth>
            {t("mka_login_btn")}
          </Button>
        </Box>
      </Box>
    </AuthShell>
  );
}
